import axios from "axios";

import { useContext, useEffect } from "react";
import { useState } from "react";
import { Modal } from 'react-responsive-modal';
import { useHistory } from "react-router-dom";
import { Context } from "../../context";
import { ReassignMerch } from "../ReassignMerch/component";
import { Badge } from "@merchstores/shared/elements/Badge";
import { Card } from "@merchstores/shared/elements/Card";
import { Logo } from "@merchstores/shared/elements/Logo";
import { Progress } from "@merchstores/shared/elements/Progress";
import { ActionDropdown } from "@merchstores/shared/elements/ActionDropdown";
import { FilterIndicator } from "@merchstores/shared/elements/FilterIndicator";
import { FilterDropdown } from "@merchstores/shared/elements/FilterDropdown"
import { Table } from "@merchstores/shared/elements/Table";
import { SortDropdown } from "@merchstores/shared/elements/SortDropdown"
import './styles.scss';
import { cloudinaryApplyWidthHeight } from "@merchstores/shared/components/Cloudinary";
import { AdminHeader } from "../AdminHeader";
import { CTA } from "@merchstores/shared/elements/Cta";
import { MdGroupAdd } from "react-icons/md";
import ClosedOrderDropdown from './ClosedOrderDropdown';
import { getLocalDateText } from '../DateTime/DateTimeFormat';
import { triggerCloseOrderAction } from "./CloseOrderAction";
import { exportRecipientsToNetsuite } from '../Netsuite/Recipients';
import LoadingGif from "../../assets/common/Flask-3s-200px.svg"

export const GroupOrders = (_props: any) => { // Define the actual props needed in the index file

    const { userRole, userEmail } = useContext(Context);
    const [open, setOpen] = useState(false);
    const [groupOrders, setGroupOrders] = useState([]);
    const [orderId, setOrderId] = useState('');
    const [currentMerch, setCurrentMerch] = useState('');
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);

    const [statusFilterOptions, setStatusFilterOptions] = useState([]);
    const [adminFilterOptions, setAdminFilterOptions] = useState([]);
    const [assignedFilterOptions, setAssignedFilterOptions] = useState([]);

    const [statusFilterChosen, setStatusFilterChosen] = useState('');
    const [adminFilterChosen, setAdminFilterChosen] = useState('');
    const [assignedFilterChosen, setAssignedFilterChosen] = useState('');
    const [sortOptionChosen, setSortOptionChosen] = useState('dateDesc');

    let iconSize = isMobile ? '18px' : '22px'

    useEffect(() => {
        if (userRole && userEmail) {
            const fetchGroupOrders = async () => {
                axios.post('/.netlify/functions/fetchGroupOrders', { sorting: sortOptionChosen, email: userEmail, role: userRole })
                    .then((res) => {
                        let data = res.data.map((groupOrder: any) => {
                            const currentSubmissions = groupOrder?.members?.filter((g: any) => g.submissionId && g.submissionId !== "").length;
                            const invitedMembers = groupOrder?.members?.filter((g: any) => g.invited === true);

                            let dropDownOptions: any[] = [];
                            switch (userRole) {
                                case "MERCHOLOGIST":
                                case "ADMIN":
                                    dropDownOptions =
                                        [
                                            {
                                                title: "View/Edit",
                                                id: `${groupOrder.groupOrderId}-view`,
                                                action: () => {
                                                    history.push(`/admin/group-orders/${groupOrder.groupOrderId}`);
                                                }
                                            },
                                            {
                                                title: "Close",
                                                id: `${groupOrder.groupOrderId}-close`,
                                                action: () => {
                                                    triggerCloseOrderAction(groupOrder.groupOrderId).then(res => {
                                                        groupOrder.status = "closed";
                                                        exportRecipientsToNetsuite(groupOrder.groupOrderId, userEmail);
                                                        // orders model has some issues that prevents correct re-render 
                                                        // on update so we fetch and rebuild it again
                                                        fetchGroupOrders();
                                                    });
                                                }
                                            }
                                        ]
                                    break;
                                case "SUPERUSER":
                                    dropDownOptions =
                                        [
                                            {
                                                title: "View/Edit",
                                                id: `${groupOrder.groupOrderId}-view`,
                                                action: () => {
                                                    history.push(`/admin/group-orders/${groupOrder.groupOrderId}`);
                                                }
                                            },
                                            {
                                                title: "Reassign",
                                                id: `${groupOrder.groupOrderId}-reassign`,
                                                action: () => {
                                                    onOpenModal();
                                                    setOrderId(groupOrder.groupOrderId);
                                                    setCurrentMerch(groupOrder.merchologist)
                                                }
                                            },
                                            {
                                                title: "Close",
                                                id: `${groupOrder.groupOrderId}-close`,
                                                action: () => {
                                                    triggerCloseOrderAction(groupOrder.groupOrderId).then(res => {
                                                        groupOrder.status = "closed";
                                                        exportRecipientsToNetsuite(groupOrder.groupOrderId, userEmail);
                                                        // orders model has some issues that prevents correct re-render 
                                                        // on update so we fetch and rebuild it again
                                                        fetchGroupOrders();
                                                    });
                                                }
                                            }
                                        ]
                                    break;
                            }

                            // takes the existing default menu and replaces with a new one if the order
                            // is closed 
                            dropDownOptions = ClosedOrderDropdown.resolveDropdownOptions(
                                groupOrder, userRole, userEmail, history, dropDownOptions
                            );

                            let data: any = {};
                            const optimizedLogo = cloudinaryApplyWidthHeight(groupOrder.storeLogo, "72", "72");
                            data.logo = {
                                desktopOnly: false,
                                value: <a href={`/admin/group-orders/${groupOrder.groupOrderId}`} className="" >
                                    <Logo size="small" imgUrl={optimizedLogo} />
                                    <div className="text-left pl-3 font-bold text-merch-dark-gray pt-3 w-200">{groupOrder.name}</div>
                                </a>
                            };

                            if (userRole !== "ADMIN") {
                                data.groupAdmin = {
                                    desktopOnly: true,
                                    value: <div className="text-left pl-10 font-bold text-merch-dark-gray text-opacity-50">{groupOrder.groupAdmin}</div>
                                };
                            }

                            if (userRole !== "MERCHOLOGIST" && userRole !== 'ADMIN') {
                                data.assignedTo = {
                                    desktopOnly: true,
                                    value: <div className="text-left font-bold text-merch-dark-gray text-opacity-50">{groupOrder.merchologist}</div>
                                }
                            }

                            data.groupOrderId = {
                                desktopOnly: true,
                                value: <div className="text-center font-bold text-merch-dark-gray text-opacity-50">{groupOrder.groupOrderId}</div>
                            }
                            data.openDate = {
                                desktopOnly: true,
                                value: <div className="font-bold text-merch-dark-gray">{getLocalDateText(groupOrder.openDate)}</div>
                            }
                            data.closeDate = {
                                desktopOnly: true,
                                value: <div className="font-bold text-merch-dark-gray">{getLocalDateText(groupOrder.closeDate)}</div>
                            }
                            data.progress = {
                                desktopOnly: false,
                                value: invitedMembers.length === 0 ? <div className="font-bold text-merch-dark-gray text-13">{currentSubmissions}</div> : <Progress progress={{ total: groupOrder.members?.length, value: currentSubmissions }} bgcolor="#F26522" />
                            }
                            data.status = {
                                desktopOnly: false,
                                value: <Badge className="no-text-mobile" type={groupOrder.status.toLowerCase()}>{groupOrder.status}</Badge>
                            }
                            data.actions = {
                                desktopOnly: false,
                                value: <ActionDropdown title="Actions" list={dropDownOptions} />
                            }

                            return {
                                tr: {
                                    class: `${groupOrder.status.toLowerCase()}`,
                                    data
                                }
                            }
                        })
                        /** 'Customer Contact' filter options */
                        const adminFilterArray = () => {
                            const array: any[] = [];
                            for (let groupOrder of data) {
                                let groupAdmin = groupOrder.tr.data.groupAdmin.value.props.children
                                let groupOrderId = groupOrder.tr.data.groupOrderId.value.props.children
                                /**
                                 * So the drop down doesn't show duplicates...
                                 * If the groupAdmin is not already in our filterArray, then push it in 
                                */
                                if (!array.find(admin => admin["title"] === groupAdmin)) {
                                    array.push(
                                        {
                                            title: `${groupAdmin}`,
                                            id: `${groupOrderId}`,
                                            action: () => {
                                                setTableLoading(true)
                                                setAdminFilterChosen(groupAdmin)
                                            }
                                        }
                                    );
                                }
                            }
                            array.sort((a, b) => a.title.localeCompare(b.title))
                            setAdminFilterOptions(array)
                        }
                        /**  Only look for "Customer Contact" filter options if user is a super user */
                        userRole !== "ADMIN" && adminFilterArray();

                        /**  'Merchology Contact' filter options */
                        const assignedFilterArray = () => {
                            const array: any[] = [];
                            for (let groupOrder of data) {
                                let assignedTo = groupOrder.tr.data.assignedTo.value.props.children
                                let groupOrderId = groupOrder.tr.data.groupOrderId.value.props.children
                                /**
                                 * So the drop down doesn't show duplicates...
                                 * If the assignedTo member is not already in our filterArray, then push it in 
                                */
                                if (!array.find(assigned => assigned["title"] === assignedTo)) {
                                    if (assignedTo !== undefined) {
                                        array.push(
                                            {
                                                title: `${assignedTo}`,
                                                id: `${groupOrderId}`,
                                                action: () => {
                                                    setTableLoading(true)
                                                    setAssignedFilterChosen(assignedTo)
                                                }
                                            }
                                        );
                                    }
                                }
                            }
                            array.sort((a, b) => a.title.localeCompare(b.title))
                            setAssignedFilterOptions(array)
                        }
                        /**  Only look for "Merchology Contact" filter options if user is a super user */
                        userRole !== "MERCHOLOGIST" && userRole !== "ADMIN" && assignedFilterArray();

                        /** Check if there is a filter chosen to filter the orders by */
                        if (statusFilterChosen && adminFilterChosen && assignedFilterChosen) {
                            const array: any[] = []
                            for (let groupOrder of data) {
                                const groupOrderType = groupOrder.tr.data.status.value.props.type;
                                const groupOrderAdmin = groupOrder.tr.data.groupAdmin.value.props.children;
                                const assignedTo = groupOrder.tr.data.assignedTo.value.props.children;
                                if (groupOrderType === statusFilterChosen && groupOrderAdmin === adminFilterChosen && assignedTo === assignedFilterChosen) {
                                    array.push(groupOrder)
                                }
                            }
                            if (sortOptionChosen === 'submissionsDesc' || sortOptionChosen === 'submissionsAsc') {
                                handleSubmissionSorting(array)
                            } else {
                                setGroupOrders(array)
                            }
                        }
                        else if (statusFilterChosen && adminFilterChosen) {
                            const array: any[] = []
                            for (let groupOrder of data) {
                                const groupOrderType = groupOrder.tr.data.status.value.props.type;
                                const groupOrderAdmin = groupOrder.tr.data.groupAdmin.value.props.children;
                                if (groupOrderType === statusFilterChosen && groupOrderAdmin === adminFilterChosen) {
                                    array.push(groupOrder)
                                }
                            }
                            if (sortOptionChosen === 'submissionsDesc' || sortOptionChosen === 'submissionsAsc') {
                                handleSubmissionSorting(array)
                            } else {
                                setGroupOrders(array)
                            }
                        }
                        else if (statusFilterChosen && assignedFilterChosen) {
                            const array: any[] = []
                            for (let groupOrder of data) {
                                const assignedTo = groupOrder.tr.data.assignedTo.value.props.children;
                                const groupOrderType = groupOrder.tr.data.status.value.props.type;
                                if (groupOrderType === statusFilterChosen && assignedTo === assignedFilterChosen) {
                                    array.push(groupOrder)
                                }
                            }
                            if (sortOptionChosen === 'submissionsDesc' || sortOptionChosen === 'submissionsAsc') {
                                handleSubmissionSorting(array)
                            } else {
                                setGroupOrders(array)
                            }
                        }
                        else if (adminFilterChosen && assignedFilterChosen) {
                            const array: any[] = []
                            for (let groupOrder of data) {
                                const assignedTo = groupOrder.tr.data.assignedTo.value.props.children;
                                const groupOrderAdmin = groupOrder.tr.data.groupAdmin.value.props.children;
                                if (groupOrderAdmin === adminFilterChosen && assignedTo === assignedFilterChosen) {
                                    array.push(groupOrder)
                                }
                            }
                            if (sortOptionChosen === 'submissionsDesc' || sortOptionChosen === 'submissionsAsc') {
                                handleSubmissionSorting(array)
                            } else {
                                setGroupOrders(array)
                            }
                        }
                        else if (statusFilterChosen) {
                            const array: any[] = []
                            for (let groupOrder of data) {
                                const groupOrderType = groupOrder.tr.data.status.value.props.type;
                                if (groupOrderType === statusFilterChosen) {
                                    array.push(groupOrder)
                                }
                            }
                            if (sortOptionChosen === 'submissionsDesc' || sortOptionChosen === 'submissionsAsc') {
                                handleSubmissionSorting(array)
                            } else {
                                setGroupOrders(array)
                            }
                        }
                        else if (adminFilterChosen) {
                            const array: any[] = []
                            for (let groupOrder of data) {
                                const groupOrderAdmin = groupOrder.tr.data.groupAdmin.value.props.children;
                                if (groupOrderAdmin === adminFilterChosen) {
                                    array.push(groupOrder)
                                }
                            }
                            if (sortOptionChosen === 'submissionsDesc' || sortOptionChosen === 'submissionsAsc') {
                                handleSubmissionSorting(array)
                            } else {
                                setGroupOrders(array)
                            }

                        }
                        else if (assignedFilterChosen) {
                            const array: any[] = []
                            for (let groupOrder of data) {
                                const assignedTo = groupOrder.tr.data.assignedTo.value.props.children;
                                if (assignedTo === assignedFilterChosen) {
                                    array.push(groupOrder)
                                }
                            }
                            if (sortOptionChosen === 'submissionsDesc' || sortOptionChosen === 'submissionsAsc') {
                                handleSubmissionSorting(array)
                            } else {
                                setGroupOrders(array)
                            }

                        }
                        else {
                            if (sortOptionChosen === 'submissionsDesc' || sortOptionChosen === 'submissionsAsc') {
                                handleSubmissionSorting(data)
                            }
                            else {
                                setGroupOrders(data);
                            }
                        }
                        if(groupOrders) {setTimeout(() => setLoading(false), 500)}
                        if(groupOrders) {setTimeout(() => setTableLoading(false), 60)}
                    })
                    .catch(err => {
                        console.error(err);
                    })
                    
            };
            fetchGroupOrders();
            /** Since we can't sort by progress with a DB call, this uses .sort to sort the array of orders by progress  */
            const handleSubmissionSorting = (data: any[]) => {
                if (sortOptionChosen === 'submissionsDesc') {
                    setGroupOrders(data.sort((a: any, b: any) => {
                        let aProgress = a.tr.data.progress.value.props.progress ? a.tr.data.progress.value.props.progress.value : 0
                        let bProgress = b.tr.data.progress.value.props.progress ? b.tr.data.progress.value.props.progress.value : 0
                        if (aProgress > bProgress) {
                            return -1
                        } else {
                            return 1
                        }

                    }))
                }
                else if (sortOptionChosen === 'submissionsAsc') {
                    setGroupOrders(data.sort((a: any, b: any) => {
                        let aProgress = a.tr.data.progress.value.props.progress ? a.tr.data.progress.value.props.progress.value : 0
                        let bProgress = b.tr.data.progress.value.props.progress ? b.tr.data.progress.value.props.progress.value : 0
                        if (aProgress > bProgress) {
                            return 1
                        } else {
                            return -1
                        }

                    }))
                }
            }
        }
        let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        setIsMobile(isMobile);
    }, [sortOptionChosen, statusFilterChosen, adminFilterChosen, assignedFilterChosen, userRole, currentMerch, history, userEmail]);

    useEffect(() => {
        /** 'Status' filter options */
        setStatusFilterOptions([
            {
                title: "Active",
                id: "statusFilterActive",
                action: () => {
                    setTableLoading(true)
                    setStatusFilterChosen('active')
                }
            },
            {
                title: "Draft",
                id: "statusFilterDraft",
                action: () => {
                    setTableLoading(true)
                    setStatusFilterChosen('draft')
                }
            },
            {
                title: "Closed",
                id: "statusFilterClosed",
                action: () => {
                    setTableLoading(true)
                    setStatusFilterChosen('closed')
                }
            }
        ]);



    }, [groupOrders, userRole]); // end useEffect

    const sortOptions = [
        {
            title: isMobile ? "Order A - Z" : "Order Name A - Z",
            id: "name_a-z",
            action: () => {
                setSortOptionChosen('nameDesc')
            }
        },
        {
            title: isMobile ? "Order Z - A" : "Order Name Z - A",
            id: "name_z-a",
            action: () => {
                setSortOptionChosen('nameAsc')
            }
        },
        {
            title: isMobile ? "Open Date (Oldest)" : "Open Date (Oldest First)",
            id: "date_oldest",
            action: () => {
                setSortOptionChosen('dateAsc')
            }
        },
        {
            title: isMobile ? "Open Date (Newest)" : "Open Date (Newest First)",
            id: "date_newest",
            action: () => {
                setSortOptionChosen('dateDesc')
            }
        },
        {
            title: isMobile ? "Close Date (Oldest)" : "Close Date (Oldest First)",
            id: "close_date_oldest",
            action: () => {
                setSortOptionChosen('closeDateAsc')
            }
        },
        {
            title: isMobile ? "Close Date (Newest)" : "Close Date (Newest First)",
            id: "close_date_newest",
            action: () => {
                setSortOptionChosen('closeDateDesc')
            }
        },
        {
            title: isMobile ? "Submissions (Fewest)" : "Submissions (Fewest First)",
            id: "submissions_fewest",
            action: () => {
                setSortOptionChosen('submissionsAsc')
            }
        },
        {
            title: isMobile ? "Submissions (Most)" : "Submissions (Most First)",
            id: "submissions_most",
            action: () => {
                setSortOptionChosen('submissionsDesc')
            }
        },
    ]

    let columns: any[] = [];

    switch (userRole) {
        case "MERCHOLOGIST":
            columns =
                [
                    {
                        text: "Group Order",
                        class: "text-left"
                    },
                    {
                        text: "Customer Contact",
                        class: "text-left pl-10"
                    },
                    {
                        text: "Order ID",
                    },
                    {
                        text: "Open",
                    },
                    {
                        text: "Close",
                    },
                    {
                        text: "Submissions",
                    },
                    {
                        text: "Status",
                    },
                    {
                        text: ""
                    }
                ]
            break;
        case "ADMIN":
            columns =
                [
                    {
                        text: "Group Order",
                        class: "text-left"
                    },
                    {
                        text: "Order ID",
                    },
                    {
                        text: "Open",
                    },
                    {
                        text: "Close",
                    },
                    {
                        text: "Submissions",
                    },
                    {
                        text: "Status",
                    },
                    {
                        text: ""
                    }
                ]
            break;
        default:
            columns = [
                {
                    text: "Group Order",
                    class: "text-left"
                },
                {
                    text: "Customer Contact",
                    class: "text-left pl-10"
                },
                {
                    text: "Merchology Contact",
                    class: "text-left"
                },
                {
                    text: "Order ID",
                    class: "text-center"
                },
                {
                    text: "Open Date",
                },
                {
                    text: "Close Date",
                },
                {
                    text: "Submissions",
                },
                {
                    text: "Status",
                },
                {
                    text: ""
                }
            ]
            break;
    }

    const onOpenModal = () => {
        setOpen(true);
    }

    const onCloseModal = () => setOpen(false);

    const removeFilter = (clickedFilter: string) => {
        setTableLoading(true)

        if(clickedFilter === 'status') {
            setStatusFilterChosen('')
        } else if(clickedFilter === 'admin') {
            setAdminFilterChosen('')
        }
        else if(clickedFilter === 'assignedTo') {
            setAssignedFilterChosen('')
        }
    }

    if (loading) return <div className="h-screen flex items-center justify-center"><img src={LoadingGif} alt="loading flask" width="100px"/></div>

    return (
        <>
            <AdminHeader title="Group Orders" subtitle={new Date().toDateString()}>
                {userRole !== "ADMIN" &&
                    <div>
                        <CTA disabled={false} size="standard" type="primary" icon={<MdGroupAdd size={iconSize}/>} onClick={() => history.push("/admin/group-orders/new")} mobileIconView={true}>{"New Group Order"}</CTA>
                    </div>
                }
            </AdminHeader>
            <div className="flex justify-between dropdowns-container">
                <div className="filter-dropdowns">
                    <FilterDropdown
                        title="Status"
                        list={statusFilterOptions}
                        chosenFilter={statusFilterChosen}
                        btnClass="status-orders-page" />
                    {userRole !== "ADMIN" &&
                        <FilterDropdown
                            title="Customer Contact"
                            list={adminFilterOptions}
                            chosenFilter={adminFilterChosen}
                            btnClass={userRole === "SUPERUSER" ? "super-admin-orders" : "admin-orders-page"} />
                    }
                    {userRole !== "MERCHOLOGIST" && userRole !== "ADMIN" &&
                        <FilterDropdown
                            title="Merchology Contact"
                            list={assignedFilterOptions}
                            chosenFilter={assignedFilterChosen}
                            btnClass="assigned-orders-page" />
                    }
                </div>
                <div className="sort-orders-container"> <SortDropdown title="Sort" list={sortOptions} defaultSort="date_newest" /> </div>
            </div>
            <div className="filters-chosen-container">
                {statusFilterChosen && <FilterIndicator title={statusFilterChosen} onRemove={() => removeFilter('status')} />}
                {adminFilterChosen && <FilterIndicator title={adminFilterChosen} onRemove={() => removeFilter('admin')} />}
                {assignedFilterChosen && <FilterIndicator title={assignedFilterChosen} onRemove={() => removeFilter('assignedTo')} />}
            </div>
            <div className="group-orders-container">
                <Card data-class="group-orders">
                    {tableLoading ? 
                        <div className="h-screen flex items-center justify-center"><img src={LoadingGif} alt="loading flask" width="75px"/></div>
                        :  
                        <Table itemsName="orders" name="group-orders" filter={true} columns={columns} data={groupOrders} elementsPerPage={50}/>
                    } 
                </Card>
                <Modal open={open} onClose={onCloseModal} center classNames={{ modal: "reassign-merch-modal" }}>
                    <ReassignMerch
                        currentMerch={currentMerch}
                        setCurrentMerch={setCurrentMerch}
                        currentOrderId={orderId}
                        open={open}
                        setOpen={setOpen} />
                </Modal>
            </div>
        </>
    )
}